import { render, staticRenderFns } from "./AddressEmployeeDialog.vue?vue&type=template&id=876a5ec4&scoped=true&lang=pug&"
import script from "./AddressEmployeeDialog.vue?vue&type=script&lang=ts&"
export * from "./AddressEmployeeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddressEmployeeDialog.vue?vue&type=style&index=0&id=876a5ec4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876a5ec4",
  null
  
)

export default component.exports